module.exports = __webpack_public_path__ + "static/media/HMS.8f5667c9.jpg";